// Human-friendly document numbers.
//
// Jobs store a per-org integer job_number (see migration
// 20260707140000_per_org_job_numbers) and are shown as JOB-0001. Invoices
// already store their own text number (INV-0001), so this only formats jobs.

export function formatJobNumber(n: number | null | undefined): string {
    if (n == null || !Number.isFinite(Number(n))) return 'JOB—';
    return `JOB-${String(Math.trunc(Number(n))).padStart(4, '0')}`;
}
